const chn = [
  //login
  "请输入发送至+{area}{phone}的验证码，有效期5分钟",
  //finishingdialog
  "{freeTicketCount}张",
  //identity
  "剩余{time}s",
  //drawCalendar
  "日历风格 --2",
  //common
  "到期",
  "一大波新品即将上新...",
  "这个debug用",
  "选择月",
  "分享链接",
  "复制",
  "分享二维码",
];
let lang = {};
chn.map((v) => {
  var text = v;
  if (v.match(/\s--\d/i)) {
    //可以写“ --2”结尾避免重复
    text = text.substring(0, text.length - 4);
  }
  lang[v] = text;
});

module.exports = lang;
